import React from 'react';

import { Checkbox } from 'components/WrappedComponents';
import { FieldProps } from 'components/WrappedComponents/Form/FormWrapper/type';
import { CreationCompteFormValues } from 'types/Compte/CreationCompte';
import { CSSUtils } from 'utils/CSSUtils';

function CheckboxActif({
  values,
}: FieldProps<CreationCompteFormValues>): React.ReactElement {
  const key: keyof CreationCompteFormValues = 'actif';

  return (
    <Checkbox
      wrapperProps={{
        values: values,
        fieldKey: key,
        itemProps: {
          label: 'Utilisateur activé',
          labelCol: { span: CSSUtils.defaultLabelCol },
          wrapperCol: { span: CSSUtils.largeWrapperCol },
        },
      }}
      checkboxProps={{ disabled: true }}
    />
  );
}

export default CheckboxActif;
